/**
 * @generated SignedSource<<2adce026d254012de760237772539f4f>>
 * @relayHash de2c1a144c6655a00dc78c43d23da62d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61f52182754428702f90636faa4979214d661c760938519d4258efa3e358dcf5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { StakeholdersPageQuery } from './StakeholdersPageQuery.graphql';

const node: PreloadableConcreteRequest<StakeholdersPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "61f52182754428702f90636faa4979214d661c760938519d4258efa3e358dcf5",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "stakeholderComms_listStakeholders"
          ]
        }
      ]
    },
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
